module.exports = __webpack_public_path__ + "img/phone_3.6f008d85.webp";